import React from "react";
import {
  IonHeader,
  IonButtons,
  IonToolbar,
  IonTitle,
  IonContent,
  IonPage,
  IonBackButton,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/react";
import { RefresherEventDetail } from "@ionic/core";
import { chevronDownCircleOutline } from 'ionicons/icons';
import "./layout.css";



function doRefresh(event: CustomEvent<RefresherEventDetail>) {
  console.log('Begin async operation');

  setTimeout(() => {
    console.log('Async operation has ended');
    event.detail.complete();
  }, 2000);
}

const PageLayout: React.FC<{
  title?: string;
  customHeader?: Boolean;
  toolbar?: JSX.Element;
  header?: JSX.Element;
  buttons?: JSX.Element;
}> = ({ children, title, customHeader, header, toolbar, buttons }) => {
  return (
    <>
      <IonPage>
        {!customHeader && (
          <IonHeader className="ion-no-border">
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonBackButton />
              </IonButtons>
              <IonTitle>{title}</IonTitle>
              {buttons && <IonButtons slot="end">{buttons}</IonButtons>}
            </IonToolbar>
            {toolbar && toolbar}
          </IonHeader>
        )}
        {customHeader && header}
        
        <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
        <IonRefresherContent
          pullingIcon={chevronDownCircleOutline}
          pullingText="Tarik untuk me-refresh"
          refreshingSpinner="crescent"
          refreshingText="Sedang me-refresh. . .">
        </IonRefresherContent>
      </IonRefresher>
          {children}
          </IonContent>
      </IonPage>
    </>
  );
};

export default PageLayout;
